import React from 'react';
import styled from 'styled-components';

import FunnelUpdateName from '../../../containers/funnel/update/Name';
import FunnelClosingRangePicker from '../../../containers/funnel/update/ClosingRangePicker';

const StyledFunnelUpdateHeader = styled.div`
  background-color: rgb(247, 246, 244);
  padding: 15px;
`;

const FunnelUpdateHeader = () => (
  <StyledFunnelUpdateHeader>
    <FunnelUpdateName />
    <FunnelClosingRangePicker />
  </StyledFunnelUpdateHeader>
);

export default FunnelUpdateHeader;
